import * as React from 'react';
import { useSelector } from 'react-redux';

import { ResultsLegFragment } from '@websky/graphql';
import { useRenderers } from '../../../../../../renderProps';
import { getIsExchangeAutoMode, getOrderId } from '../../../../../../Checkout/store/order/selectors';
import Flight from '../../../../../../Flight/Flight';

import { getSelectedExchangeVariants, getSelectedFlightsCount } from '@entities/exchange';
import { useSelectFlight } from '../../model/useSelectFlight';

interface Props {
	flight: ResultsLegFragment;
}

const SelectFlight: React.FC<Props> = ({ flight }) => {
	const orderId = useSelector(getOrderId);
	const selectedFlightsCount = useSelector(getSelectedFlightsCount);
	const selectedFares = useSelector(getSelectedExchangeVariants);
	const isAutoMode = useSelector(getIsExchangeAutoMode);

	const isHidePrice = !isAutoMode;
	const isEmptyPrices = flight.pricesForFareGroups.every(
		priceGroup => !priceGroup.prices || priceGroup.prices.every(price => !price.price)
	);

	const { onSelectExchangeFlight } = useSelectFlight();
	const { ExchangeFlight = Flight } = useRenderers();

	return (
		<ExchangeFlight
			orderId={orderId}
			flight={flight}
			selectedFares={selectedFares}
			hidePrice={isHidePrice}
			hideOnlyPrice={isEmptyPrices}
			isReturnFlight={selectedFlightsCount === 1}
			isPreOpen={false}
			isPreOpenAvailable={false}
			onSelect={onSelectExchangeFlight}
		/>
	);
};

export default SelectFlight;
